import {PublicInfoType} from "./publicInfoType.model";
import {ContactType} from "./contactType.model";
import {DocumentInfoType} from "./documentInfoType.model";
import {PersonalDataType} from "./personalDataType.model";
import {FIOType} from "./fioType.model";
import {AddressInfoType} from "./addressInfoType.model";
import {OrgNameType} from "./orgNameType.model";
import {DictType} from "./dictType.model";
import {
  DossierINNType,
  DossierKPPType,
  DossierN9,
  DossierOKPOULType,
  DossierT100,
  DossierT11,
  DossierT19
} from "./base.model";
import {OkvedType} from "./okvedType.model";
import {RegInfoType} from "./regInfoType.model";
import {LicenseType} from "./licenseType.model";

export class SvedKOType {
  orgName: OrgNameType = new OrgNameType();
  opf: DictType = undefined;
  opfn?: DossierT100 = undefined;
  okfs?: DictType = undefined;
  inn?: DossierINNType = '';
  taxtin?: DossierT19 = '';
  kpp?: DossierKPPType = undefined;
  bik?: DossierN9 = '';
  swift?: DossierT11 = '';
  okpo: DossierOKPOULType = '';
  oktmo: DictType = undefined;
  okved: OkvedType = new OkvedType();
  regInfo: RegInfoType = new RegInfoType();
  licenseInfo?: Array<LicenseType> = undefined;
  addressInfo: AddressInfoType = new AddressInfoType();
  contactInfo: ContactType = new ContactType();
}
